export const View = {
  MAP: 'MAP',
  LIST: 'LIST',
};
